<template>
  <div class="p-box">
    <div class="con-search">
      <van-field v-model="teamName" placeholder="搜索团队成员名称/手机号码" />
      <div @click="onsearch" class="s-icon"></div>
    </div>
    <div class="team-peo-box">
      <div class="team-peo-nav">
        <div
          v-for="(item,index) in pickerList"
          :key="index"
          @click="checkNav(item,index)"
          class="team-peo-font"
        >
          <div>{{item.name}}</div>
          <svg-icon :icon-class="isCheck==item.name?'team_icon1':'team_icon0'"></svg-icon>
        </div>
      </div>
      <div class="team-peo-data" v-for="(item,index) in dataList" :key="index">
        <dir class="data-list data-list-top">
          <div class="data-list-top-img">
            <img class="user-img" :src="item.avatarName ? item.avatarName : headerImg" alt />
          </div>
        </dir>
        <div class="data-list-bot">
          <div class="list-top-r">
            <div class="user-name">{{item.realName?item.realName:item.nickName}}</div>
            <img src="@/assets/publicImg/vip.png" alt />
            <van-tag v-if="item.showTag==1" color="#FFA800">直系</van-tag>
            <van-tag v-if="item.showTag==0" color="#FDA829" plain>非直系</van-tag>
          </div>
          <div class="data-list num-div">
            <dir class="user-clients">
              客户数：
              <span class="user-num">{{item.cusNum}}</span>
            </dir>
            <p class="team-line"></p>
            <dir class="user-incomings">
              进件数：
              <span class="user-num">{{item.orderNum}}</span>
            </dir>
          </div>
          <div class="user-timer">注册时间：{{item.createTime}}</div>
        </div>
      </div>
      <div class="hint-div" v-if="isShow">暂无数据~~~</div>
    </div>
    <van-popup v-model="defaultSort" position="bottom" closeable>
      <div class="default-sort">
        <div>选择排序</div>
        <div class="sort-title">
          <div
            :class="sort==item.type?'sort-sty sort-link-sty':'sort-sty'"
            v-for="(item,index) in sortColumns"
            :key="index"
            @click="onChangeSort(item,index)"
          >{{item.title}}</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="isBusiness" position="bottom" closeable>
      <div class="default-sort">
        <div>业务类型</div>
        <div class="sort-title">
          <div
            :class="business==item.type?'sort-sty sort-link-sty':'sort-sty'"
            v-for="(item,index) in businessColumns"
            :key="index"
            @click="onbusiness(item,index)"
          >{{item.title}}</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="moreFilters" position="bottom" closeable>
      <div class="default-sort">
        <div>更多筛选</div>
        <div class="has-order-tit">是否进件</div>
        <div class="has-order">
          <div
            :class="hasOrder===item.type ? 'more-sty more-link-sty' : 'more-sty'"
            v-for="(item,index) in moreColumns"
            :key="index"
            @click="onHasOrder(item,index)"
          >{{item.title}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import URLTB from "@/api/apiTB";
import URL from "@/api/api";
export default {
  data() {
    return {
      teamName: '',
      isCheck: '默认排序',
      sort: '',//排序分类 下拉
      pickerList: [
        { name: '排序', icon: 'team_icon0', icon1: 'team_icon1' },
        { name: '业务类型', icon: 'team_icon0', icon1: 'team_icon1' },
        { name: '是否进件', icon: 'team_icon0', icon1: 'team_icon1' },
      ],
      dataList: [],
      defaultSort: false,//默认排序下拉
      //   sortColumns: ['默认排序', '按客户数量排序', '按进件数量排序', '按团队成员规模排序'],
      sortColumns: [
        { type: '', title: '默认排序' },
        { type: 'cus', title: '按客户数量排序' },
        { type: 'order', title: '按进件数量排序' },
      ],
      business: '',//已做业务分类
      isBusiness: false,//已做业务
      businessColumns: [
        { type: '', title: '全部' },
        { type: 'loan', title: '贷款' },
        { type: 'insurance', title: '保险' },
      ],
      moreFilters: false,//更多筛选 
      hasOrder: '',//更多筛选分类
      moreColumns: [
        { type: '', title: '不限' },
        { type: 1, title: '进件' },
        { type: 0, title: '未进件' },
      ],
      headerImg: require('./img/team-img.png'),
      isShow:false//dataList是否有数据
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onsearch() {//搜索
      this.dataList=[]
      this.getData()
    },
    checkNav(n, i) {
      this.isCheck = n.name
      if (n.name == '排序') {
        this.defaultSort = true
      } else if (n.name == '业务类型') {
        this.isBusiness = true
      } else {
        this.moreFilters = true
      }
    },
    getData() {
      let data = {
        userId: localStorage.getItem('userid'),
        sort: this.sort,//cus-客户数量 order-进件数量
        business: this.business,//业务 loan-贷款 insurance-保险
        hasOrder: this.hasOrder,//是否已有进件  0-无 1-已有 null-不限
        searchStr:this.teamName
      }
      this.$fetchPost(URL.teamPeople.url, this.$toFormData(data)).then(res => {
        console.log(res, 'team-pro');
        if(res.data.code==20000){
          this.dataList = res.data.data
          if(this.dataList?.length==0){
            this.isShow=true
          }
        }else{
          Toast(res.data.msg)
        }
        // if(res.data.data.data!=null){
        //   this.dataList.map(x => {
        //   if (x.realName.length == 2) {
        //     x.newNmae = x.realName.substr(0, 1) + "*"
        //   } else if (x.realName.length == 3) {
        //     x.newNmae = x.realName.substr(0, 1) + "**"
        //   } else if (x.realName.length == 4) {
        //     x.newNmae = x.realName.substr(0, 2) + "**"
        //   }
        // })
        // }
      })
    },
    onChangeSort(v, i) {
      this.sort = v.type
      this.getData()
      this.defaultSort = false
    },
    onbusiness(v, i) {
      this.business = v.type
      this.getData()
      this.isBusiness = false
    },
    onHasOrder(v, i) {
      this.hasOrder = v.type
      this.getData()
      this.moreFilters = false
    },
  }
}
</script>

<style lang="less" scoped>
.p-box {
  font-family: Source Han Sans CN;
  .con-search {
    width: 355px;
    height: 30px;
    margin: 7px auto 8px auto;
    background: url("../../assets/publicImg/search-bg1.png") no-repeat 100%;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-cell {
      width: 300px;
      height: 30px;
      line-height: 30px;
      padding: 0 0 0 13px;
      background: transparent;
    }
    .s-icon {
      width: 40px;
      height: 30px;
      line-height: 27px;
    }
  }
  .team-peo-box {
    padding-bottom: 30px;
    .team-peo-nav,
    .team-peo-font {
      display: flex;
      align-items: center;
      font-size: 13px;
      font-weight: Regular;
      color: #333333;
    }
    .team-peo-nav {
      margin-top: 23.5px;
    }
    .team-peo-font {
      &:not(:first-child){
        margin-left: 35px;
      }
      .svg-icon {
        width: 8px;
        height: 8px;
        margin-left: 5px;
      }
    }
    .team-peo-data {
      width: 355px;
      height: 100px;
      margin-top: 15px;
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      .data-list {
        display: flex;
        align-items: center;
        // overflow: hidden;
        .team-line {
          width: 0.5px;
          height: 6.5px;
          background: #eaeaea;
        }
      }
      .data-list-top {
        width: 61px;
        margin-top: 12px;
        .data-list-top-img {
          display: flex;
          margin: auto;
          .user-img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
      }
      .data-list-bot {
        margin-top: 15px;
        font-weight: 400;
        font-size: 11px;
        color: #333333;
        .list-top-r {
          display: flex;
          img {
            width: 62px;
            height: 15px;
            display: block;
            margin-left: 5px;
          }
          .van-tag {
            margin-left: 11px;
          }
          .user-name {
            max-width: 75px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
            font-weight: 500;
          }
        }
        .num-div{
          margin: 10px 0;
          .user-incomings{
            margin-left: 50px;
          }
        }
      }
    }
    .hint-div{
      margin-top: 20px;
      text-align: center;
      font-size: 12px;
      color: #999;
    }
  }
  .van-popup {
    width: 375px;
    height: 339.5px;
    .default-sort {
      // // margin-top: 38px;
      // margin-left: 20px;
      padding: 38px 20px 0 20px;
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      .sort-title {
        margin-top: 71px;
        text-align: center;
      }
      .sort-sty {
        font-size: 13px;
        font-weight: Regular;
        color: #999999;
      }
      .sort-sty:not(:first-child) {
        margin-top: 22.5px;
      }
      .sort-link-sty {
        color: #fc6e09;
      }
    }
    /deep/.van-popup__close-icon--top-right {
      top: 38px;
      right: 20px;
    }
    .has-order-tit {
      margin-top: 24px;
      font-size: 13px;
      font-weight: Regular;
      color: #333333;
    }
    .has-order {
      display: flex;
      .more-sty {
        width: 50.5px;
        height: 21px;
        margin: 28px 15px 0 0;
        line-height: 21px;
        text-align: center;
        background: #fbfbfb;
        border-radius: 13.5px;
        font-size: 10.5px;
        color: #999999;
      }
      .more-link-sty {
        color: #fc6e09;
      }
    }
  }
}
</style>